<div class="mainHolder">
  <div class="title">
    <ion-button
      class="sideButton"
      fill="clear"
      [bpDisplayIfCanGoBack]="false"
      (click)="navigationButtonClick(false)"
    >
      <ion-icon
        slot="icon-only"
        name="menu"
        [style.color]="contrast"
      ></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      [bpDisplayIfCanGoBack]="true"
      [bpDisplayIfStackOfResources]="isFactsheet"
      (click)="navigationButtonClick(true)"
    >
      <ion-icon
        slot="icon-only"
        name="arrow-back"
        [style.color]="contrast"
      ></ion-icon>
    </ion-button>
    <div class="titleContainer" [style.color]="contrast">
      <bepatient-skeleton
        *ngIf="enableSkeleton && !title"
        className="toolbar-header left"
      ></bepatient-skeleton>
      <span class="title" [innerHTML]="title"></span>
      <span class="subtitle" [innerHTML]="subtitle"></span>
    </div>
    <ion-button fill="clear" (click)="gotoTimeline(true)" *ngIf="close">
      <ion-icon
        slot="end"
        name="close-outline"
        [style.color]="contrast"
        style="font-size: 1.8em; --ionicon-stroke-width: 64px"
      ></ion-icon>
    </ion-button>
    <div
      *ngIf="enableSkeleton || icon"
      class="iconContainer"
      [style.background]="icon ? contrast : 'transparent'"
    >
      <bepatient-skeleton
        *ngIf="enableSkeleton && !icon"
        className="toolbar-icon"
      ></bepatient-skeleton>
      <bepatient-dynamic-icon
        *ngIf="icon"
        size="24px"
        [color]="color"
        [iconName]="icon"
      >
      </bepatient-dynamic-icon>
      <!-- <ion-icon
        slot="icon-only"
        name="menu"
        [style.color]="contrast"
      ></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      [bpDisplayIfCanGoBack]="true"
      [bpDisplayIfStackOfResources]="isFactsheet"
      (click)="navigationButtonClick(true)"
    >
      <ion-icon
        slot="icon-only"
        name="arrow-back"
        [style.color]="contrast"
      ></ion-icon>
    </ion-button> -->

      <!-- <div class="titleContainer" [style.color]="contrast">
      <span class="title" [innerHTML]="title"></span>
      <span class="subtitle" [innerHTML]="subtitle"></span>
    </div>
    <ion-button fill="clear" (click)="gotoTimeline(true)" *ngIf="close">
      <ion-icon
        slot="end"
        name="close-outline"
        [style.color]="contrast"
        style="font-size: 1.8em; --ionicon-stroke-width: 64px"
      ></ion-icon>
    </ion-button>
    <div *ngIf="icon" class="iconContainer" [style.background]="contrast">
      <bepatient-dynamic-icon size="24px" [color]="color" [iconName]="icon">
      </bepatient-dynamic-icon>
    </div> -->
    </div>
  </div>

  <!--
<div *ngIf="allowExtension" class="image">
  <img [src]="image" [style.opacity]="imageOpacity" />
</div>
-->

  <ng-container *ngIf="formForActivities && !hideSelector">
    <div
      class="activity"
      *ngIf="displayActivity"
      bpAddRtlClass
      [style.display]="'none'"
    >
      <div
        class="activity-date"
        [style.color]="formForActivities.color"
        [style.display]="
          formForActivities.activities[formForActivities.activities.length - 1]
            .date
            ? 'block'
            : 'none'
        "
        *ngIf="
          formForActivities.activities.length === 1 ||
            !formForActivities.canChangeActivity;
          else useSelector
        "
      >
        {{
          formForActivities.activities[formForActivities.activities.length - 1]
            .date
            ? formForActivities.activities[
                formForActivities.activities.length - 1
              ].date
            : ('FORM_V2.NEW_ACTIVITY' | translate)
        }}
      </div>
      <ng-template #useSelector>
        <ion-select
          interface="popover"
          [value]="formForActivities.selectedActivity"
          [style.color]="formForActivities.color"
          (ionChange)="formForActivities.selectedActivity = $event.detail.value"
        >
          <ion-select-option
            *ngFor="let activity of formForActivities.activities"
            [value]="activity"
          >
            {{
              (activity.date && activity.date) ||
                ('FORM_V2.NEW_ACTIVITY' | translate)
            }}
          </ion-select-option>
        </ion-select>
      </ng-template>
    </div>
  </ng-container>
</div>
